import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './inverseSlider.module.css';


function InverseSlide(props) {
    return (
        <div className={styles.inverseSlideItem}>
            <div className={styles.slideItemWrap}>
                <div className={styles.siContentWrap}>
                    <div className={styles.mobileImageWrap}>
                        {
                            (props.item.image) ?
                            <img src={props.item.image.image.asset.url} alt="" />
                            : ``
                        }
                    </div>
                    <h3>{props.item.title}</h3>
                    <div className={styles.siBulletContent}>
                        <div className={styles.siBullet}>
                            <span>{(props.index +1)}.</span>
                        </div>
                        <div className={styles.richtext}>
                            <h5>{props.item.heading}</h5>
                            <PortableText blocks={props.item.desc} />
                        </div>
                    </div>
                    {
                        (props.item.ctalink) ? 
                            <div className={styles.sectionCTA}>
                                <a href={props.item.ctalink} className={styles.ctalink}>
                                    <span>{props.item.ctalabel}</span>
                                </a>
                            </div>
                        : ``
                    }
                </div>
                <div className={styles.siImageWrap}>
                    {
                        (props.item.image) ?
                        <img src={props.item.image.image.asset.url} alt="" />
                        : ``
                    }
                    <div className={styles.downloadLinks}>
                        {
                            (props.appStore && props.item.showDownloadLinks) ?
                            <div className={styles.appStore}>
                                <a href={props.appStore}>
                                    <img src={require('../images/apple.png').default} alt="App Store" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.googlePlay && props.item.showDownloadLinks) ?
                            <div className={styles.googlePlay}>
                                <a href={props.googlePlay}>
                                    <img src={require('../images/google.png').default} alt="App Store" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.item.showDomainIcon) ?
                            <div className={styles.domainTab}>
                                <a href="javascript:void(0);">
                                    <img src={require('../images/domain-tab.png').default} alt="domain.com.au" />
                                </a>
                            </div>
                            : ``
                        }
                        {
                            (props.item.showCongratsIcon) ?
                            <div className={styles.congratsTab}>
                                <a href="javascript:void(0);">
                                    <img src={require('../images/congrats-tab.png').default} alt="Congratulations" />
                                </a>
                            </div>
                            : ``
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
  
export default InverseSlide;